import HooksView from "@features/tools/view/hooks-view";

const Hooks = () => {
  return <HooksView />;
};

export default Hooks;
